import { ICartEntry } from '@rbi-ctg/menu';
import { useLoyaltyRewardsList } from 'hooks/use-loyalty-rewards-list';
import { useLoyaltyContext } from 'state/loyalty';

export const useRedeemReward = (item?: ICartEntry) => {
  const {
    stagedCartPoints,
    appliedLoyaltyRewards,
    totalTimesRewardApplied,
    availableLoyaltyRewardsMap,
    loyaltyEnabled,
  } = useLoyaltyContext();
  const { sanityRewardsMap, loading } = useLoyaltyRewardsList();

  if (!item || !loyaltyEnabled) {
    return {
      rewardRedeemable: false,
      incentiveNotInMenu: false,
      redeemRewardLoading: false,
      hasSufficientBalance: false,
      limitPerOrderMet: false,
    };
  }

  const numberOfTimesRewardApplied = appliedLoyaltyRewards[item.cartId]?.timesApplied;

  const reward = availableLoyaltyRewardsMap[item._id];

  const { value: rewardId } =
    reward?.metadata?.find(metadata => metadata?.key === 'externalReferenceId') || {};

  const { incentiveNotInMenu } = sanityRewardsMap?.[rewardId] || {};

  const { pointCost, id } = reward || {};

  const maxRedemptionsMet = numberOfTimesRewardApplied >= item.quantity;

  const limitPerOrderMet =
    !!reward?.limitPerOrder && totalTimesRewardApplied[id] === reward.limitPerOrder;

  const hasSufficientBalance = pointCost && stagedCartPoints >= pointCost;

  const rewardRedeemable = hasSufficientBalance && !maxRedemptionsMet && !limitPerOrderMet;

  return {
    rewardRedeemable,
    incentiveNotInMenu: Boolean(incentiveNotInMenu),
    redeemRewardLoading: loading,
    hasSufficientBalance,
    limitPerOrderMet,
  };
};
